import React, { useState ,useEffect} from 'react';

import '../../Assets/css/custom.css';
import '../../Assets/css/w3-css.css';
import {Link} from 'react-router-dom';
import {Redirect} from 'react-router-dom';
import Container from 'react-bootstrap/Container';
import Navbar from 'react-bootstrap/Navbar';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import Table from 'react-bootstrap/Table';
import Header from '../../Common/Header';
import Modal from 'react-bootstrap/Modal';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";  

import CommonAPI from '../../Common/CommonAPI';
import CommonAPI2 from '../../Common/FD_BILL_APIs';
import moment from 'moment';
import FadeLoader from "react-spinners/HashLoader";    
import SuccessMSG from "../../Common/SuccessMsg"; 

function  BillRemoveRecipient (props) { 

  const [BillType,setBillType] = useState([]);

  const [RegSelectedBill,setRegSelectedBill] = useState();
  const [RegesterBillTypeName,setRegesterBillTypeName] = useState();
  const [BillRegisterType,setBillRegisterType] = useState();
  const [BillingCode,setBillingCode] = useState();
  const [BillingAccount,setBillingAccount] = useState();
  const [BillServiceProvider,setBillServiceProvider] = useState([]);
  const [Password,setPassword] = useState();
  const [RegServiceProviderCode,setRegServiceProviderCode] = useState();
  const [RegServiceProviderName,setRegServiceProviderName] = useState();
  const [SuccessfulMSG,setSuccessfulMSG] = useState();
  const [ErrorMSG,setErrorMSG] = useState();
  const [EnterDate,setEnterDate] = useState();
  const [AccountNumber,setAccountNumber] = useState();
  const [BillingId,setBillingId] = useState();
  

  const BillTypeAPI = ()=>{
    CommonAPI2.BillPaymentType((result)=>{
      setBillType(result);
    }
   )
  }
  useEffect( () => {
    BillTypeAPI();        
  },[]);

  const GetBillingAccount = (type)=> {
    var passValFrom = JSON.parse(type.target.value);  
       
    passValFrom ==='Select Bill'?
    setRegSelectedBill('')
    :setRegSelectedBill(passValFrom.type);
    setRegesterBillTypeName(passValFrom.name);
    setBillRegisterType(passValFrom.type);  

    if(passValFrom.type){
      GetExistRecipientAPI(passValFrom.type)
    }
  }

  const GetExistRecipientAPI = (type) =>{
    CommonAPI2.GetExistBillRecipient({type:type},(result)=>{
      result.map((list,index)=>{        
          setBillingCode(list.code);
          setBillServiceProvider(result);        
      })
    })
  }
  const RegServiceProvider = (type) =>{
    var BillingCodeVal = JSON.parse(type.target.value);    
      setAccountNumber(BillingCodeVal.billingAccount);
      setBillingId(BillingCodeVal.id);  
      setEnterDate(BillingCodeVal.enterDate)
  }

  const CheckPassword = () =>{  
    if(RegSelectedBill==="Select Bill" ||!RegSelectedBill){
      setErrorMSG("Select a Bill Payment Type");
    }else if(!BillingId){
      setErrorMSG("Select a Billing Account");
    }else{
    CommonAPI.CheckPassword({password:Password},(results) =>{ 
     if(results.password==="true"){
         setErrorMSG();
         RemoveRecipientAPI();
     }else{
         setErrorMSG("Enter Correct Password");
     }
    })
  }
  }
  const RemoveRecipientAPI = () =>{
    CommonAPI2.RemoveBillRecipient({BillingId:BillingId},(result)=>{
      if (result.message==='Success'){       
        
        setBillType([]);
        setBillServiceProvider([]);
        setPassword("");
        setBillingAccount('');
        setRegSelectedBill();
        setAccountNumber(); 
        setBillingId();       
        setErrorMSG("");        
        BillTypeAPI(); 
        setSuccessfulMSG(true);
      }else{        
        setErrorMSG("Recipient Remove Unsuccess");        
       
      }
    })
  }
  if(SuccessfulMSG){
    return(
    <SuccessMSG ConfirmSuccess={SuccessfulMSG} onHide={()=>setSuccessfulMSG(false)} 
    Close={()=>setSuccessfulMSG(false)} head="SUCCESSFULLY" head2="REMOVED" 
    contentline1="Successfully Removed Your Recipient"
    />)
  }

        return (

            <Modal
              show={props.isOpen}
              size="md"
              aria-labelledby="contained-modal-title-vcenter"
              centered 
              backdrop="static"
              onHide={props.toggle}
            >
              <Modal.Header closeButton>
                <Modal.Title  id="contained-modal-title-vcenter">
                  <p className='modal-head-f'>MAINTAIN</p><br/>BILL RECIPIENT
                </Modal.Title>
              </Modal.Header>
              <Modal.Body>
                
                <Form >
                    <Form.Group as={Row} className="mb-1">
                        <Form.Label className="c-font" column sm={5}>
                        Bill Payment Type
                        </Form.Label>
                        <Col sm={7}>
                        <Form.Select 
                        onChange={GetBillingAccount.bind(this)}
                        size="sm" 
                        className="form-h2 ">
                            <option value={JSON.stringify("Select Bill")}>Select</option>
                            {BillType?BillType.map((listValue,index)=> {
                              return(<option key={index} value={JSON.stringify(listValue)}>{listValue.name}</option>)
                            }):null
                            }                           
                        </Form.Select>
                        </Col>
                    </Form.Group>
                    {RegSelectedBill?
                    
                    <Form.Group as={Row} className="mb-1" >
                        <Form.Label className="c-font" column sm={5}>
                           Billing Account
                        </Form.Label>
                        <Col sm={7}>
                        <Form.Select 
                        onChange={RegServiceProvider.bind(this)}
                        size="sm" className="form-h2 ">
                        <option value={JSON.stringify("Select Service Provider")}>Select Service Provider-</option>
                          {BillServiceProvider.map((ListValue,index)=> {
                            return(<option value={JSON.stringify(ListValue)}>{ListValue.provider}{" - "+ListValue.billingAccount}</option>)
                          })
                          }
                        </Form.Select>
                        </Col>
                    </Form.Group>
                    
                    :null
                    }                   
                    {AccountNumber?
                    <div>
                      <Form.Group as={Row} className="mb-1" >
                          <Form.Label className="c-font" column sm={5}>
                            Account Number
                          </Form.Label>
                          <Form.Label className="c-font" column sm={7}>
                            {AccountNumber}
                          </Form.Label>
                      </Form.Group>
                      <Form.Group as={Row} className="mb-1" >
                          <Form.Label className="c-font" column sm={5}>
                            Enter
                          </Form.Label>
                          <Form.Label className="c-font" column sm={7}>
                            {moment(EnterDate).format("DD/MM/YYYY")}
                          </Form.Label>
                      </Form.Group>
                    </div>
                    :null}
                    <Form.Group as={Row} className="mb-1" >
                        <Form.Label className="c-font" column sm={5}>
                          Password To Confirm Remove Recipient
                        </Form.Label>
                        <Col sm={7} >
                         <Form.Control maxLength={8}
                         onChange={(e)=>setPassword(e.target.value)} 
                         className={!Password?"form-h2 password-f":"form-h2"} size="sm" type="password" placeholder="Password" />
                        </Col>
                        <p className='vali-txt'>{ErrorMSG}</p>
                    </Form.Group>
                </Form>
              </Modal.Body>
              <Modal.Footer className="mb-1 margintop-f2">    
                <Button className="btn-logout rm-btn" onClick={()=>CheckPassword()}>REMOVE</Button> 
              </Modal.Footer>
            </Modal>
          );
    }

export default BillRemoveRecipient;